
import AddToCartCta from './add-to-cart.vue'
export default {
  name: 'CtaMain',
  components: { AddToCartCta },
  props: {
    wording: {
      type: Object,
      required: true,
    },
    product: {
      type: Object,
      required: true,
    },
    inWishlist: {
      type: Boolean,
      required: true,
      default: false,
    },
  },

  methods: {
    handleAddToCart() {
      if (!this.product.availability || parseFloat(this.product.price) === 0) {
        return false
      } else {
        this.$emit('addToCart')
      }
    },
  },
}
